(function ($) {
    $(document).ready(function () {

        // For each instance of the Social Slider.
        $.each($('.image-scroller'), function () {
            let slides_to_show = $(this).attr('data-slides-to-show');
            let scrolling_speed  = $(this).attr('data-speed');

            /**
             * on the slider init event, remove the empty id attributes that Slick adds.
             */
            $($(this)).on("init", () => {
                $($(this)).find("[id]").filter((_, element) => element.id === "").removeAttr("id");
            });

            /**
             * Initialize the carousel.
             */
            $($(this)).slick({
                infinite: true,
                speed: scrolling_speed > 0 ? scrolling_speed : 10000,
                autoplay: true,
                autoplaySpeed: 0,
                slidesToShow: 5,
                slidesToScroll: 1,
                cssEase: 'linear',
                pauseOnHover: true,
                arrows: false,
                responsive: [
                    // {
                    //     breakpoint: 3160,
                    //     settings: {
                    //         slidesToShow: 14,
                    //     }
                    // },
                    // {
                    //     breakpoint: 2780,
                    //     settings: {
                    //         slidesToShow: 12,
                    //     }
                    // },
                    // {
                    //     breakpoint: 2380,
                    //     settings: {
                    //         slidesToShow: 10,
                    //     }
                    // },
                    // {
                    //     breakpoint: 2000,
                    //     settings: {
                    //         slidesToShow: 8,
                    //     }
                    // },
                    // {
                    //     breakpoint: 1600,
                    //     settings: {
                    //         slidesToShow: 6,
                    //     }
                    // },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 1120,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                ]
            });
        });

    });
})(jQuery);
